// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {FETCH_ENTITLEMENTS, CLEAR_ENTITLEMENTS} from '../actions/entitlements'

const initialState = {
  entitlements: null
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_ENTITLEMENTS:
      return {...state, entitlements: action.payload}
    case CLEAR_ENTITLEMENTS:
      return {...state, entitlements: null}
    default:
      return state
  }
}
